import styled from '@emotion/styled'
import type { FC } from 'react'

import { css } from '@emotion/react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CardBase, * as CardRecipe from '@segment/matcha/recipes/Card'

import type { Lesson } from '@segment/api/routes/growthMasters/queries'

const copy = {
  heading: `Resources`,
}

interface ResourcesProps {
  resources: Lesson[`resources`]
}
const Resources: FC<ResourcesProps> = ({ resources }) => {
  const shrinkColumn = resources.length < 3
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <StyledCopyTextHeading tag="h3" variant="h2">
            {copy.heading}
          </StyledCopyTextHeading>
        </CopyTextBase>
      </Section.Copy>
      <StyledSectionContents shrinkColumn={shrinkColumn}>
        <ColumnTrack
          overrides={{
            sm: 1,
            lg: resources.length >= 3 ? 3 : resources.length,
          }}
        >
          {resources.map((card, key) => (
            <CardBase key={card.title + key} href={card.url} data-dynamic-link="true">
              <CardRecipe.Body>
                <CardRecipe.Copy>
                  <CardRecipe.Headline tag="h3">{card.title}</CardRecipe.Headline>
                </CardRecipe.Copy>
                <CardRecipe.Action alignment="right">
                  <ChevronRightIcon />
                </CardRecipe.Action>
              </CardRecipe.Body>
            </CardBase>
          ))}
        </ColumnTrack>
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-bottom: 40px;
  }
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  max-width: 684px;
  margin: 0 auto;
`

interface StyledSectionContentsProp {
  shrinkColumn: boolean
}
const StyledSectionContents = styled(Section.Contents)<StyledSectionContentsProp>`
  ${({ shrinkColumn }) =>
    shrinkColumn &&
    css`
      max-width: 855px;
    `}
`

export default Resources
